import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import EyeWhite from "../../../../../../images/EyeWhite.svg";
import { AtsItemGroup, AtsItemGroupEdge } from "../queries/types";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import { AssignAssetProps } from "../asset/GroupingAsset";
import { Operation } from "../../../../../../utils/Enum.types";
import Add, { AssignAssetPageFor } from "../asset/Add";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import AssociateItemDetails from "../asset/AssociateGroupItemsDetails";

interface Props {
  itemGroups: AtsItemGroupEdge[];
  handleScroll: (e: React.UIEvent<HTMLUListElement, UIEvent>) => void;
}

const AssetList = ({ itemGroups, handleScroll }: Props) => {
  const navigate = useNavigate();

  const { customer_id, company_id } = useUrlParams();
  const { state, dispatch } = useContext(AppContext);

  const [assignAsset, setAssignAsset] = useState<AssignAssetProps>({
    flag: false,
    operation: Operation.NONE,
  });

  const LiTag = ({ node }: { node: AtsItemGroup }) => {
    return (
      <li>
        <b>{node.groupName}</b>
        <div className="assign-asset__block--total">
          <span>Total</span>
          <b>{node.totalQty}</b>
        </div>
        <button
          className="assign-asset__block--view"
          onClick={() => {
            navigate(
              `/${customer_id}/company/${company_id}/masters/grouping/assign/${node.id}`
            );
          }}
        >
          view <img src={EyeWhite} alt="" />
        </button>
      </li>
    );
  };

  return (
    <>
      <div className="assign-asset__block">
        <ul onScroll={handleScroll}>
          {itemGroups.map((itm) => {
            return <LiTag node={itm.node} />;
          })}
        </ul>
      </div>
      <CustomModal
        style={ViewModalStyles}
        isOpen={assignAsset.flag}
        onRequestClose={() =>
          setAssignAsset({
            flag: false,
            operation: Operation.NONE,
          })
        }
        contentComponent={
          <AssociateItemDetails
            setModal={setAssignAsset}
            operation={assignAsset.operation}
          />
        }
      />
    </>
  );
};

export default AssetList;
